import { render, staticRenderFns } from "./SharedData.vue?vue&type=template&id=64a46bef&scoped=true&"
import script from "./SharedData.vue?vue&type=script&lang=js&"
export * from "./SharedData.vue?vue&type=script&lang=js&"
import style0 from "./SharedData.vue?vue&type=style&index=0&id=64a46bef&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64a46bef",
  null
  
)

export default component.exports